import { IUserOrganisation } from '../apis/UserMgtAPI/model/userInfo';
import { IEntity } from '../interfaces/entity';

export interface IUserList {
  items: User[];
  totalCount: number;
}

export class UserOrganisation implements IUserOrganisation {
  id: number;
  uid: string;
  userId: number;
  organisationId: number;

  constructor(userOrganisation?: UserOrganisation) {
    this.id = userOrganisation.id;
    this.uid = userOrganisation.uid;
    this.userId = userOrganisation.userId;
    this.organisationId = userOrganisation.organisationId;
  }
}

export class User implements IEntity {
  id: number;
  uid: string;
  username?: string;
  email?: string;
  dateOfAgreement?: Date;
  telephone?: string;
  mobile?: string;
  dateCreated?: Date;
  firstName?: string;
  lastName?: string;
  lastUpdated?: Date;
  canLogin?: boolean;
  isAdmin?: boolean;
  managerId?: number;
  costPerHour?: number;
  receiveNewReferralNotifications?: boolean;
  receiveRetentionNotifications?: boolean;
  canViewArchive?: boolean;
  canDeleteAttachments?: boolean;
  canCloseCases?: boolean;
  canExportData?: boolean;
  organisationId?: number;
  hasCasePrepAccess?: boolean;
  userOrganisations: UserOrganisation[] = [];
  role: string;

  constructor(user?: User) {
    if (user === undefined) {
      return;
    }
    this.id = user.id;
    this.uid = user.uid;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.dateCreated = user.dateCreated;
    this.dateOfAgreement = user.dateOfAgreement;
    this.email = user.email;
    this.mobile = user.mobile;
    this.telephone = user.telephone;
    this.username = user.username;
    this.lastUpdated = user.lastUpdated;
    this.canLogin = user.canLogin;
    this.isAdmin = user.isAdmin;
    this.managerId = user.managerId;
    this.costPerHour = user.costPerHour;
    this.receiveNewReferralNotifications = user.receiveNewReferralNotifications;
    this.receiveRetentionNotifications = user.receiveRetentionNotifications;
    this.canViewArchive = user.canViewArchive;
    this.canDeleteAttachments = user.canDeleteAttachments;
    this.canCloseCases = user.canCloseCases;
    this.canExportData = user.canExportData;
    this.organisationId = user.organisationId;
    this.hasCasePrepAccess = user.hasCasePrepAccess;
    this.userOrganisations = user.userOrganisations;
    this.role = user.role;
  }

  public get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }
}
